import { GUI } from "dat.gui";
import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/tema6/GLB_LataAtun.glb";
import gsap from "gsap";

export class Lata extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(3, 3, 3)
		this.rotation.y = -1.67
		// this.helpers()
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Lata_Atun = gltf.scene.getObjectByName("Lata_Atun", true);
		});
	}

	helpers() {
		const gui = new GUI();
		const folderLata = gui.addFolder("Lata");
		const limit = 20;
		folderLata.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderLata.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderLata.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderLata.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderLata.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderLata.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderLata.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderLata.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderLata.add(this, "visible").name("Visible");
	}
	move() {
		this.clearAnimation()
		this.Lata_Atun.animation = gsap.to(this.Lata_Atun.position, {
			x: 0.15,
			duration: 0.5,
			delay: 0.5,
			ease: "none",
		});
	}
	remove() {
		this.clearAnimation()
		this.Lata_Atun.animation = gsap.to(this.Lata_Atun.position, {
			x: 0,
			duration: 0.5,
			delay: 0.5,
			ease: "none",
		});
	}
	clearAnimation() {
		if (this.Lata_Atun.animation) {
			this.Lata_Atun.animation.kill();
		}
	}
}
